import { render, staticRenderFns } from "./InspectionReview.vue?vue&type=template&id=888aa466&"
import script from "./InspectionReview.vue?vue&type=script&lang=js&"
export * from "./InspectionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports